import { defineCustomElement } from '@tyler-components-web/core';
import { DividerComponent } from './divider';
export * from './divider-constants';
export * from './divider';
export function defineDividerComponent() {
    defineCustomElement(DividerComponent);
}
